import { pathToRegexp } from 'path-to-regexp';

import {
  guruleadsPageRoute,
  landingPageRoute,
  leadSuPageRoute,
  mainPageRoute,
  microcreditSelectionRoute,
  newMicrocreditsPageRoute,
  onlinePageRoute,
  partnersPageRoute,
  productPageRoute,
  promotionPageRoute,
  seoListRegionRoutes,
  seoListRoutes,
  seoSelectRegionRoutes,
  specOffersLandingPageRoute,
} from '../shared/constants/pageRoutes';

const mapRoutesToPages = (arr: readonly string[], to: string): Record<string, string> =>
  Object.fromEntries(arr.map((url) => [url, to]));

const routes = {
  [landingPageRoute]: '/landing',
  [promotionPageRoute]: '/promotion',
  [onlinePageRoute]: '/online',
  [leadSuPageRoute]: '/leadssu',
  [guruleadsPageRoute]: '/guruleads',
  [newMicrocreditsPageRoute]: '/novinki',
  [productPageRoute]: '/item',
  [partnersPageRoute]: '/partners',
  [specOffersLandingPageRoute]: '/special',

  ...mapRoutesToPages([mainPageRoute, ...seoListRoutes, ...seoListRegionRoutes], '/list'),
  ...mapRoutesToPages(seoSelectRegionRoutes, '/regions'),
};

const mapUrlToNextUrl = (urlCompare: string): string | undefined => {
  if (microcreditSelectionRoute === urlCompare) return undefined;
  return Object.entries(routes).find(([url]) => pathToRegexp(url).test(urlCompare))?.[1];
};

export const getUrl = (urlCompare: string): string => mapUrlToNextUrl(urlCompare) ?? urlCompare;
